import { SVGProps } from "react";

const LocationIcon = ({ fill, ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_728_1775)">
        <path
          d="M9.5 0.486816C6.33717 0.486816 3.69922 3.03459 3.69922 6.2876C3.69922 7.52517 4.0711 8.62872 4.78481 9.66281L9.05608 16.3277C9.26329 16.6517 9.73713 16.6511 9.94392 16.3277L14.2337 9.64013C14.9321 8.65291 15.3008 7.4937 15.3008 6.2876C15.3008 3.08905 12.6986 0.486816 9.5 0.486816ZM9.5 8.92432C8.04618 8.92432 6.86328 7.74141 6.86328 6.2876C6.86328 4.83378 8.04618 3.65088 9.5 3.65088C10.9538 3.65088 12.1367 4.83378 12.1367 6.2876C12.1367 7.74141 10.9538 8.92432 9.5 8.92432Z"
          fill={fill ?? "#1F1F1F"}
        />
        <path
          d="M13.6226 12.605L10.9672 16.7565C10.2798 17.8281 8.71633 17.8246 8.0323 16.7575L5.37259 12.6061C3.03245 13.1471 1.58984 14.1383 1.58984 15.3227C1.58984 17.378 5.66544 18.4868 9.5 18.4868C13.3346 18.4868 17.4102 17.378 17.4102 15.3227C17.4102 14.1374 15.9656 13.1458 13.6226 12.605Z"
          fill={fill ?? "#1F1F1F"}
        />
      </g>
      <defs>
        <clipPath id="clip0_728_1775">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.5 0.486816)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LocationIcon;
